<!-- Featured Buttons -->
<div class="row">
    <div class="col-md-12">
        <div class="col-md-4">
            <button type="button" class="btn btn-sm btn-secondary tt mb-1 mr-1" (click)="print()" placement="bottom" [disabled]="dftCount < 1" ngbTooltip="Print List">
                <i class="fa fa-lg fa-print"></i>
                <span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Print</span>
            </button>

            <div class="btn-group mr-1">
                <button type="button" class="btn btn-sm btn-secondary dropdown-toggle mb-1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" [disabled]="dftCount < 1">
                    <i class="fa fa-lg fa-download"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Export</span>
                </button>
                <div class="dropdown-menu fs-12">
                        <a (click)="driverFitTest_exportToCSV()" class="dropdown-item" href="javascript:void(0);">Export to CSV</a> 
                        <a (click)="driverFitTest_exportToExcel()" class="dropdown-item" href="javascript:void(0);">Export to Excel</a> 
                        <a (click)="driverFitTest_exportToPDF()" class="dropdown-item" href="javascript:void(0);">Export to PDF</a> 
                </div>
            </div>

            <button type="button" [ngClass]="(showFilters)?'btn-success':'btn-secondary'" class="btn btn-sm mb-1 mr-1"(click)="toggleFilters()" placement="bottom" ngbTooltip="Filter List">
                <i class="fa fa-lg fa-filter"></i>
                <span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Filter</span>
            </button>
            
            <div class="btn-group mb-1">
                <button type="button" class="btn btn-secondary btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span class="sr-only">Toggle Dropdown</span>
                    <i class="fa fa-lg fa-check-square-o"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Columns</span>
                </button>
                <div class="dropdown-menu fs-12" style="width: 150px;">
                    <div class="col-md-12 mb-3 fs-12">
                        <input type="checkbox" [(ngModel)]="showDate"> Date<br />
                        <input type="checkbox" [(ngModel)]="showDriver"> Driver<br />
                        <input type="checkbox" [(ngModel)]="showDriverLicence"> Driver Licence #<br />
                        <input type="checkbox" [(ngModel)]="showStatus"> Status<br />
                        <input type="checkbox" [(ngModel)]="showFile"> File<br /> 
                    </div>
                </div>
            </div>

        </div>
    </div>
</div> <!-- End of Featured Buttons -->

<br />
<!-- Search Driver Fitness Test List -->
<div class="row">
    <div style="margin-left: 18px;"></div>
    <div class="col-md-8">
        <div widget class="card border-0 box-shadow" *ngIf="showFilters">
            <div class="card-header border-0 text-muted">
                <h5 class="mb-0">Search Drivers Fitness Tests:</h5>
                <div class="widget-controls"> 
                    <a data-widgster="close"class="transition" (click)="toggleFilters()"><i class="fa fa-times"></i></a>
                </div>  
            </div>
            <div class="card-body card-header pt-0 widget-body">
                <div class="row">
                    <div class="form-group col-md-4">
                        <label>Date:</label> 
                        <input type="date" class="form-control form-control-sm" [(ngModel)]="filterDDate"  (change)="updateFilter()">
                    </div>
                    <div class="form-group col-md-4">
                        <label>Driver:</label> 
                        <input type="text" class="form-control form-control-sm" [(ngModel)]="filterDDriver" (keyup)="updateFilter()"> 
                    </div>
                </div>
                <div class="row" *ngIf="!isFilterEmpty">
                    <div class="col-md-12">
                        <button  type="button" class="btn btn-success btn-sm mb-1" (click)="resetFilters()">
                                <span class="badge badge-pill badge-white text-primary ml-1"><i class="fa fa-lg fa-filter"></i></span>
                                <span >Reset Filters</span>
                        </button> &nbsp;
                    </div>
                </div>                                  
            </div>
        </div>
    </div>
</div> <!-- End of Search Driver Fitness Test List -->

<br *ngIf="showFilters" />
<!-- DRIVER FITNESS TEST TABLE -->
<div class="card-body pt-0 widget-body">
    <ngx-loading [show]="loadingIndicator"></ngx-loading>
    <ngx-datatable  *ngIf="dftCount > 0 && !loadingIndicator"
        [loadingIndicator]="loadingIndicator"
        class="material"
        [rows]="rows"
        [columnMode]="'force'"
        [columns]="columns"
        [footerHeight]="40"
        [rowHeight]="'auto'"
        [limit]="10"
        [selected]="selected"
        [selectionType]="'single'"
        >

        <ngx-datatable-column name="Date" prop="date_done"  headerClass="header" [width]="120" *ngIf="showDate">
            <ng-template let-value="value" ngx-datatable-cell-template>
                {{ (value !== null && value != '0000-00-00') ? (value | date: 'dd MMM yyyy') : "No Date"  }}
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column *ngIf="showDriver">
            <ng-template let-column="column" ngx-datatable-header-template >
                Driver
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
                {{row.driver_first_name}} {{row.driver_last_name}}
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Driver License #" prop="driver_license_no" headerClass="header" [width]="120" *ngIf="showDriverLicence"></ngx-datatable-column>
        <ngx-datatable-column name="Status" prop="is_compliant"  headerClass="header"  [width]="120" *ngIf="showStatus">
            <ng-template let-value="value" ngx-datatable-cell-template>
                {{ value == 1 ? "Compliant" : "Non-Compliant"  }}
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="File" prop="file"  headerClass="header" [width]="220" *ngIf="showFile">
            <ng-template let-value="value" ngx-datatable-cell-template>
                <a href="{{fileStoragePath}}/compliance/{{value}}" target="_new">{{value}}</a>
            </ng-template>
        </ngx-datatable-column>
    </ngx-datatable>
</div> <!-- END OF DRIVER FITNESS TEST TABLE -->

<!-- START PRINT-->
<div id="print-section" style="display:none">
    <table style="width:100%">
            <tr>
                <th align="left">DATE</th>
                <th align="left">DRIVER</th>
                <th align="left">DRIVER LICENSE #</th>
                <th align="left">STATUS</th>
                <th align="left">FILE</th>         
            </tr>
            
            <tr *ngFor="let row of rows">
                <td>{{ (row.date_done !== null && row.date_done != '0000-00-00') ? (row.date_done | date: 'dd MMM yyyy') : "No Date"  }}</td>
                <td>{{row.driver_first_name}} {{row.driver_last_name}}</td>
                <td>{{row.driver_license_no}}</td>
                <td>{{ row.is_compliant == 1 ? "Compliant" : "Non-Compliant"  }}</td>
                <td><a href="{{fileStoragePath}}}}/compliance/{{row.file}}" target="_new">{{row.file}}</a></td>
            </tr>
    </table>
</div>
<!-- END PRINT -->